import { createContext } from 'react';
import type { StackedDialogHost } from './stackedDialog.types';

/** The dialog a `WorkspaceModal` opened inside it stacks over; null outside one. */
export const StackedDialogContext = createContext<StackedDialogHost | null>(null);
